const JOB_VIEW_ENDPOINTS = {
  RECORD: "/frontend/job-views/record",
  USAGE: "/frontend/job-views/usage",
};

export default JOB_VIEW_ENDPOINTS;
